export const sortData = (data, sortField, sortDirection) => {
  if (!sortField || !sortDirection) return data;

  const parseDate = (str) => {
    const [day, month, year] = str.split(".");
    return new Date(`${year}-${month}-${day}`);
  };

  return [...data].sort((a, b) => {
    const valA = a[sortField];
    const valB = b[sortField];

    // Ako su stringovi, ali validni datumi u formatu dd.MM.yyyy
    const isDateFormat =
      typeof valA === "string" &&
      /^\d{2}\.\d{2}\.\d{4}$/.test(valA) &&
      /^\d{2}\.\d{2}\.\d{4}$/.test(valB);

    if (isDateFormat) {
      return sortDirection === "asc"
        ? parseDate(valA) - parseDate(valB)
        : parseDate(valB) - parseDate(valA);
    }

    if (typeof valA === "string") {
      return sortDirection === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    }

    return sortDirection === "asc" ? valA - valB : valB - valA;
  });
};
